import { Container, FlexContainer, Spacing } from "manifest-components/src/Containers";
import { Button } from "manifest-components/src/Button";
import { ColorVariables } from "manifest-components/src/Colors";

import { Input } from "manifest-components/src/Inputs/Input";
import styled from "styled-components";
import DisclaimerAgreeToTermsOfServiceLogin from "manifest-components/src/LegalDisclaimer/disclaimers/DisclaimerAgreeToTermsOfServiceLogin";

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchAuthSession, fetchUserAttributes } from "aws-amplify/auth";
import PageLayout from "../../components/PageLayout";
import * as PageStyled from "../../components/HenryAssistedForm/styles";
import { newSignIn, signUpWithGoogle } from "../../utils/amplify";
import { route, RoutePaths } from "../../routes/RoutePaths";
import Authentication from "../../utils/authentication";

const StyledHeader = styled(FlexContainer)`
  text-align: left;
  justify-content: flex-start;
  h1 {
    font-size: 28px;
    line-height: 36px;
  }
  @media (min-width: 769px) {
    text-align: center;
    justify-content: center;
    h1 {
      font-size: 32px;
      line-height: 40px;
    }
  }
`;

const StyledLink = styled.button`
  cursor: pointer;
`;

const LoginScreen = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const onSubmitHandler = async (e) => {
    e.preventDefault();
    const res = await newSignIn({ username: email, password });
    console.log({ res });
    const nextStep = res.nextStep.signInStep;
    const isMFASelection = nextStep === "CONTINUE_SIGN_IN_WITH_MFA_SELECTION";
    const isEMAILMFA = nextStep === "CONFIRM_SIGN_IN_WITH_EMAIL_CODE";
    const isSMSMFA = nextStep === "CONFIRM_SIGN_IN_WITH_SMS_CODE";
    if (isMFASelection || isEMAILMFA || isSMSMFA) {
      let redirectURI = route(RoutePaths.mfa) as string;
      if (isEMAILMFA) {
        redirectURI += `?choice=EMAIL`;
      }
      if (isSMSMFA) {
        redirectURI += `?choice=SMS`;
      }
      return navigate(redirectURI, {
        state: {
          email,
          mfaDetails: res.nextStep.codeDeliveryDetails,
        },
      });
    }

    if (res.nextStep.signInStep === "DONE") {
      const userRes = await fetchUserAttributes();
      const userSessionRes = await fetchAuthSession();

      const accessToken = userSessionRes.tokens?.accessToken.toString();
      Authentication.authenticate({
        accessToken,
        userId: userRes.sub,
        email: userRes.email,
      });

      return navigate("/test/home");
    }
  };

  const onClickSignUpWithGoogle = async () => {
    await signUpWithGoogle();
  };

  return (
    <PageLayout pageId="login">
      <PageStyled.HenryAssistedFormContainer>
        <StyledHeader>
          <h1>Welcome back</h1>
        </StyledHeader>

        <Spacing $space={40} />
        <Button text="Sign up with Google" onClick={onClickSignUpWithGoogle} name="signupWithGoogle" />
        <form onSubmit={onSubmitHandler}>
          <Container className="tile-section-a">
            <Input
              name="email"
              autoComplete
              onChange={setEmail}
              title="Email"
              value={email}
              titleColor={ColorVariables.coco9}
            />
            <Input
              name="password"
              autoComplete
              data-head-redact-text="true"
              onChange={setPassword}
              title="Password"
              type="password"
              value={password}
              titleColor={ColorVariables.coco9}
            />
          </Container>
          <Container className="button-section">
            <Button name="login" type="submit" text="Log in" />
          </Container>
          <Container className="disclaimer">
            <DisclaimerAgreeToTermsOfServiceLogin />
          </Container>
        </form>
      </PageStyled.HenryAssistedFormContainer>
    </PageLayout>
  );
};

export { LoginScreen };
